<template>
  <Loading v-if="loading" />
  <div class="authenticateCallerSMS">
    <img
      class="authenticateCallerSMS-img"
      :src="
        isFailed
          ? require('@/assets/icons/AuthenticationFailedRegister.svg')
          : require('@/assets/icons/AuthenticationSuccessRegister.svg')
      "
      alt=""
    />
    <p class="authenticateCallerSMS-title">
      {{
        isFailed
          ? $t('authenticationRegisterFailed')
          : $t('authenticationRegisterSuccess')
      }}
    </p>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { mapActions, mapState } from 'vuex';

import Loading from '@/views/Loading.vue';

@Options({
  name: 'AuthenticateCallerSMS',
  components: {
    Loading
  },
  data() {
    return {
      loading: false
    };
  },
  computed: {
    ...mapState('callerAuthentication', ['status']),
    isFailed() {
      return this.status.message;
    }
  },
  created() {
    this.show();
  },
  methods: {
    ...mapActions('callerAuthentication', ['authenticateCallerSMS']),
    async show() {
      this.loading = true;

      const payload = {
        verificationData: window.location.search
      };

      await this.authenticateCallerSMS(payload);

      this.loading = false;
    }
  }
})
export default class AuthenticateCallerSMS extends Vue {}
</script>

<style lang="scss" scoped>
.authenticateCallerSMS {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 280px;
  height: 176px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  background-color: $light-grey;
  .authenticateCallerSMS-img {
    margin-bottom: 20px;
    background-color: $light-grey;
  }
  .authenticateCallerSMS-title {
    font-size: $fourteenSize;
    line-height: $fourteenSize;
    font-weight: 600;
    background-color: $light-grey;
  }
}
</style>
